import { Heading } from "@digdir/designsystemet-react";
import { PencilIcon } from "@navikt/aksel-icons";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import type { BestillingPageKey } from "../config";

export const HeadingWithLink = ({
  translationKey,
  changeLink,
}: {
  translationKey: string;
  changeLink: BestillingPageKey;
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex gap-0">
      <Heading data-size={"sm"}>{t(translationKey)}</Heading>
      <Link
        data-size="sm"
        to={changeLink}
        className="ml-2"
        title={t("pages.oppsummering.gå-til-endre", {
          navn: t(translationKey),
        })}
      >
        {t("pages.oppsummering.endre")}
        <PencilIcon aria-hidden />
      </Link>
    </div>
  );
};
